module.exports = __webpack_public_path__ + "img/2.67a95fda.png";